/* Rockee Redd 2.0 interactions */
(function(){
  var d=document,h=d.documentElement;
  h.classList.add('rr-js');
  var designMode=!!(window.Shopify&&window.Shopify.designMode);
  var small=window.matchMedia('(max-width: 749px)');
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* header state: one class write per change, batched to the frame */
  var scrolled=null,ticking=false;
  function applyScroll(){ticking=false;var s=window.scrollY>40;if(s!==scrolled){scrolled=s;h.classList.toggle('rr-scrolled',s);}}
  function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(applyScroll);}}
  applyScroll();
  window.addEventListener('scroll',onScroll,{passive:true});

  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting){return;}
      io.unobserve(e.target);
      requestAnimationFrame(function(){e.target.classList.add('is-in');});
    });
  },{threshold:0.08,rootMargin:'0px 0px -6% 0px'}):null;
  function scan(root){
    (root||d).querySelectorAll('[data-rr-reveal],[data-rr-clip]').forEach(function(el){
      if(io){io.observe(el);}else{el.classList.add('is-in');}
    });
  }

  function initRails(root){
    (root||d).querySelectorAll('[data-rr-rail]').forEach(function(rail){
      if(rail.rrReady){return;}
      rail.rrReady=true;
      var down=false,startX=0,startLeft=0,moved=false;
      rail.addEventListener('pointerdown',function(e){
        if(e.pointerType!=='mouse'||e.target.closest('button')){return;}
        down=true;moved=false;startX=e.clientX;startLeft=rail.scrollLeft;
      });
      window.addEventListener('pointermove',function(e){
        if(!down){return;}
        var dx=e.clientX-startX;
        if(Math.abs(dx)>6){moved=true;rail.classList.add('is-drag');}
        if(moved){rail.scrollLeft=startLeft-dx;}
      });
      window.addEventListener('pointerup',function(){
        if(!down){return;}
        down=false;
        setTimeout(function(){rail.classList.remove('is-drag');},0);
      });
      rail.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
      rail.addEventListener('dragstart',function(e){e.preventDefault();});
    });
  }

  /* proof highlights: on small screens show one at a time, cross-fading */
  function initProof(root){
    (root||d).querySelectorAll('.rr-proof').forEach(function(p){
      if(p.rrReady){return;}
      p.rrReady=true;
      var items=p.querySelectorAll('.rr-proof__item');
      if(!items.length){return;}
      var i=0;
      items[0].classList.add('is-on');
      if(items.length<2||reduce){return;}
      setInterval(function(){
        if(!small.matches||d.hidden){return;}
        items[i].classList.remove('is-on');
        i=(i+1)%items.length;
        items[i].classList.add('is-on');
      },3400);
    });
  }

  /* review quotes: native swipe, dots, gentle auto-advance until touched */
  function initQuotes(root){
    (root||d).querySelectorAll('[data-rr-quotes]').forEach(function(q){
      if(q.rrReady){return;}
      q.rrReady=true;
      var track=q.querySelector('[data-rr-quotes-track]');
      if(!track||track.children.length<2){return;}
      var dots=q.querySelectorAll('[data-rr-dot]');
      var paused=false,st;
      function cur(){return Math.round(track.scrollLeft/Math.max(1,track.clientWidth));}
      function mark(){var c=cur();dots.forEach(function(b,k){b.classList.toggle('is-on',k===c);});}
      track.addEventListener('scroll',function(){clearTimeout(st);st=setTimeout(mark,80);},{passive:true});
      ['pointerdown','touchstart','focusin'].forEach(function(ev){track.addEventListener(ev,function(){paused=true;},{passive:true});});
      dots.forEach(function(b,k){b.addEventListener('click',function(){paused=true;track.scrollTo({left:k*track.clientWidth,behavior:'smooth'});});});
      mark();
      if(reduce){return;}
      setInterval(function(){
        if(paused||d.hidden){return;}
        var r=q.getBoundingClientRect();
        if(r.bottom<0||r.top>window.innerHeight){return;}
        var n=(cur()+1)%track.children.length;
        track.scrollTo({left:n*track.clientWidth,behavior:'smooth'});
      },6000);
    });
  }

  function quickAdd(btn){
    var id=Number(btn.getAttribute('data-rr-add'));
    var label=btn.textContent;
    btn.disabled=true;btn.textContent='adding';
    var cart=d.querySelector('cart-drawer')||d.querySelector('cart-notification');
    var body={id:id,quantity:1};
    if(cart&&cart.getSectionsToRender){
      body.sections=cart.getSectionsToRender().map(function(s){return s.id;});
      body.sections_url=window.location.pathname;
    }
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json();})
      .then(function(state){
        if(state.status){throw new Error(state.description||'add failed');}
        btn.textContent='added';
        if(cart&&cart.renderContents){
          if(cart.classList.contains('is-empty')){cart.classList.remove('is-empty');}
          cart.renderContents(state);
        }
      })
      .catch(function(){var url=btn.getAttribute('data-rr-url');if(url){window.location.href=url;}})
      .finally(function(){setTimeout(function(){btn.disabled=false;btn.textContent=label;},1600);});
  }

  d.addEventListener('click',function(e){
    var add=e.target.closest('[data-rr-add]');
    if(add){e.preventDefault();quickAdd(add);return;}
    var arrow=e.target.closest('[data-rr-arrow]');
    if(arrow){
      var scope=arrow.closest('[data-rr-rail-scope]');
      var rail=scope&&scope.querySelector('[data-rr-rail]');
      if(rail){
        var card=rail.firstElementChild;
        var step=card?card.getBoundingClientRect().width+20:rail.clientWidth*0.8;
        rail.scrollBy({left:step*(arrow.getAttribute('data-rr-arrow')==='prev'?-1:1),behavior:'smooth'});
      }
      return;
    }
    /* page fade-out: pointer devices only. On phones it just adds delay. */
    if(designMode||reduce||small.matches||e.defaultPrevented||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button){return;}
    var a=e.target.closest('a[href]');
    if(!a||a.target||a.hasAttribute('download')||a.closest('cart-drawer,cart-notification,[data-rr-noleave]')){return;}
    var u;
    try{u=new URL(a.href);}catch(err){return;}
    if(u.origin!==window.location.origin){return;}
    if(u.pathname===window.location.pathname&&u.search===window.location.search){return;}
    e.preventDefault();
    h.classList.add('rr-leaving');
    setTimeout(function(){window.location.href=a.href;},170);
  });
  window.addEventListener('pageshow',function(){h.classList.remove('rr-leaving');});

  function boot(root){scan(root);initRails(root);initProof(root);initQuotes(root);}
  boot();
  d.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();
